<template>
  <div class="podcast">
    <div class="container container-fluid text-center vh-100" v-if="isLoading">
      <HMSpinner class="mt-4" />
    </div>
    <div
      class="container container-fluid text-center vh-100"
      v-if="!isLoading && !podcast"
    >
      <HMEmpty
        :image="config['page-404']"
        :title="$t('PODCASTS.TEXT.PODCAST_404_TITLE')"
        :description="$t('PODCASTS.TEXT.PODCAST_404_TEXT')"
      />
    </div>
    <div class="container podcast-container my-3 mt-5" v-if="podcast">
      <div class="row">
        <div
          clasS="col-12 d-flex flex-row justify-content-start align-items-center"
        >
          <div class="mr-3 mr-md-5">
            <PodcastThumbnail
              class="podcast-photo"
              :podcast="podcast"
              :hideOverlay="true"
            />
          </div>
          <div
            class="d-flex flex-column justify-content-start align-items-start"
          >
            <span class="c-charcoal py-1 small" v-if="podcast.num_episodes">
              {{
                $tc('PODCASTS.TEXT.EPISODES_VARIANT', podcast.num_episodes, {
                  cnt: podcast.num_episodes,
                })
              }}
            </span>
            <h1>{{ podcast.title }}</h1>
            <div
              class="d-flex flex-row justify-content-start align-items-center"
            >
              <div class="d-flex flex-wrap mr-2">
                <HMInstructorsStack
                  class="d-none d-md-flex"
                  :instructors="podcast.instructors"
                  :clickable="true"
                  size="40px"
                />
                <HMInstructorsStack
                  class="d-flex d-md-none"
                  :instructors="podcast.instructors"
                  :clickable="true"
                  size="30px"
                />
              </div>
              <span class="c-charcoal py-1 smaller" v-if="instructorsCount">
                {{
                  $tc('PODCASTS.LABELS.HOSTS_VARIANT', instructorsCount, {
                    cnt: instructorsCount,
                  })
                }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <div
            class="d-flex flex-row justify-content-between flex-wrap align-items-center w-100 bg-brand-color-03 rounded px-3 px-md-0 pl-md-4"
          >
            <div
              class="d-flex flex-row justify-content-start align-items-center py-3"
            >
              <span
                class="d-block d-flex justify-content-center align-items-center mic-icon mr-3"
              >
                <i class="fa fa-microphone-alt c-white fa-2x"></i>
              </span>
              <span class="c-charcoal">
                {{ $t('PODCASTS.TEXT.LISTEN_TO_EPISODES') }}
              </span>
            </div>
            <PodcastLinkIcons :podcast="podcast" class="px-5" />
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-12">
          <div class="episodes-list">
            <div v-for="episode in podcast.episodes" :key="episode.id">
              <router-link
                class="undecorated-router-link"
                :to="{
                  name: 'studio-podcast-episode-details',
                  params: {
                    podcast_id: episode.podcast,
                    episode_id: episode.id,
                  },
                }"
              >
                <EpisodeItem :episode="episode" />
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <hr />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { errorToMessage } from '../../../core/utils/errors';
import { getConfig } from '../../utils/configuration';
import { getStudioURL } from '@/web/router/custom-domain-utils';
import PodcastThumbnail from '../../components/podcasts/PodcastThumbnail';
import EpisodeItem from '../../components/podcasts/EpisodeItem';
import PodcastLinkIcons from '../../components/podcasts/PodcastLinkIcons';

export default Vue.extend({
  name: 'StudioPodcastDetails',
  components: {
    PodcastThumbnail,
    EpisodeItem,
    PodcastLinkIcons,
  },
  computed: {
    config() {
      return getConfig();
    },
    studioURL() {
      return getStudioURL(this.$route);
    },
    instructorsCount() {
      return this.podcast?.instructors ? this.podcast.instructors.length : 0;
    },
  },
  data() {
    return {
      isLoading: true,
      podcast: null,
    };
  },
  methods: {
    async loadData() {
      this.isLoading = true;
      try {
        this.podcast = await this.$store.dispatch(
          'podcasts/loadStudioPodcast',
          {
            studioURL: this.studioURL,
            podcastId: this.$route.params.podcast_id,
          }
        );
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to load this podcast',
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1,
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.loadData();
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.podcast-photo {
  width: 160px;
  height: 160px;
}

.mic-icon {
  background-color: var(--brand-color, $coral);
  border-radius: 50%;
  color: white;
  font-size: 12px;
  width: 40px;
  min-width: 40px;
  height: 40px;
}

.episodes-list {
  border: 1px solid $light-gray;
  border-radius: $border-radius;
}
</style>
